<template>
  <div>
    <div>
      <q-toolbar class="bg-gray shadow-4 rounded-borders">
        <q-tabs align="left" inline-label indicator-color="#9ace25">
          <q-route-tab
            v-if="comprobar_is_admin()"
            to="/Presupuestos"
            label="Listado presupuestos"
            name="listado"
          />
        </q-tabs>
      </q-toolbar>
    </div>
    <div ID="Div9" runat="server" style="background: #2222">
      <TSZ_Presupuesto />
    </div>
  </div>
</template>
<script>
import { Cookies } from 'quasar';
import TSZ_Presupuesto from '@/components/Presupuestos/components/TSZ_Presupuesto.vue';
import '@/components/Presupuestos/assets/css/css_app_vue.css';
import { QTabs, QRouteTab, QToolbar } from 'quasar';

export default {
  init () {
    this.comprobar_is_admin();
  },
  data: function () {
    return {};
  },
  methods: {
    comprobar_is_admin () {
      if (process.env.VUE_APP_ACCESO_ADMIN === '1') {
        return true;
      } else return false;
    }
  },

  components: {
    TSZ_Presupuesto,
    QTabs,
    QRouteTab,
    QToolbar
  }
};
</script>
